import Markdown from "react-markdown";

interface ParagraphBlockProps {
  text: string;
}

export function ParagraphBlock({ text }: ParagraphBlockProps) {
  return (
    <div className="prose prose-sm max-w-none leading-relaxed text-puntt-neutral-gray-12">
      <Markdown>{text}</Markdown>
    </div>
  );
}
